import { apiDelete, apiFetch } from "@/lib/api-client";
import { client } from "@duress/shared";

export async function listNotes(
  clientId: string,
): Promise<client.ClientNoteListResponse> {
  return apiFetch(
    `/clients/${clientId}/notes`,
    client.ClientNoteListResponseSchema,
  );
}

export async function createNote(
  clientId: string,
  input: client.CreateClientNoteRequest,
): Promise<client.ClientNote> {
  return apiFetch(`/clients/${clientId}/notes`, client.ClientNoteSchema, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateNote(
  clientId: string,
  noteId: string,
  input: client.UpdateClientNoteRequest,
): Promise<client.ClientNote> {
  return apiFetch(
    `/clients/${clientId}/notes/${noteId}`,
    client.ClientNoteSchema,
    {
      method: "PUT",
      body: JSON.stringify(input),
    },
  );
}

export async function deleteNote(clientId: string, noteId: string): Promise<void> {
  await apiDelete(
    `/clients/${encodeURIComponent(clientId)}/notes/${encodeURIComponent(noteId)}`,
  );
}
